<template>
    <div class="content">
        <div class="card card-default">
            <div class="card-header">
                <h3 class="card-title"> </h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-toggle="dropdown" title="Công cụ">
                        <i class="fas fa-cogs"></i>
                        <div class="input-group-prepend">
                            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                <a class="dropdown-item text-green" href="#" @click="detail(null, 'create')">
                                    <i class="fas fa-plus"></i>&nbsp;&nbsp;Tạo mới
                                </a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item text-red" href="#" @click="showDeleteManyModal()">
                                    <i class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;Xóa đã chọn
                                </a>
                                <div class="dropdown-divider"></div>
                                <export-excel class="dropdown-item text-green" :data="exportDatas" worksheet="report" type="xls" name="report.xls">
                                    <i class="fas fa-file-excel"></i>&nbsp;&nbsp;Xuất file Excel
                                </export-excel>
                                <div class="dropdown-divider"></div>
                            </div>
                        </div>
                    </button>
                    <button type="button" class="btn btn-tool" @click="getData" title="Tải lại">
                        <i class="fas fa-arrows-rotate"></i>
                    </button>
                    <!-- <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Thu gọn">
                        <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Ẩn">
                        <i class="fas fa-times"></i>
                    </button> -->

                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-md-3 mb-3">
                        <TheSelect id="" title="" :options="pageOptions" :initialValue="perPage.toString()" @onChange="(v) => onChangePageOptions(v)" />
                    </div>
                    <div class="col-md-6">
                        <select id="workspaceOptions" class="form-control select2bs4" style="width: 100%" v-model="selectedWorkspace">
                            <option v-for="item in workspaceOptions" :value="item.id" :key="item.id">{{ item.operatingCenterName }}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Nhập  từ khóa tìm kiếm" v-model="filter" v-on:keyup.enter="onSearchKey">
                            <div class="input-group-append">
                                <span class="input-group-text" @click="onSearchKey" role="button">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive p-0">
                    <!-- loading overlay -->
                    <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                    <!-- table data -->
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="col5">#</th>
                                <th class="col80">Tên lĩnh vực</th>
                                <th>Hình ảnh</th>
                                <th>Trạng thái</th>
                                <th class="col200"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in items" :key="item.id">
                                <td @click="selectRow(item.id)" style="vertical-align: middle !important;">{{ index + 1 }}</td>
                                <td @click="selectRow(item.id)" style="vertical-align: middle;">{{ item.reportName }}</td>
                                <td @click="selectRow(item.id)" style="vertical-align: middle;">
                                    <img v-if="item.imageUrl != null && item.imageUrl.trim().length > 0" width="50" v-bind:src="streamFileUrl + item.imageUrl" />
                                    <img v-if="item.imageUrl === null || item.imageUrl.trim().length <= 0" width="50" src="@/assets/no-image.png" />
                                </td>
                                <td>
                                    <TheSwitch :data="item.id" :isCheck="item.status" :onCheck="onCheckUpdateStatus" />
                                </td>
                                <!-- <td @click="selectRow(item.id)" style="vertical-align: middle;">
                                    <span v-if="item.status" class="badge badge-success">Đang hoạt động</span>
                                    <span v-if="!item.status" class="badge badge-danger">Không hoạt động</span>
                                </td> -->
                                <td style="vertical-align: middle;">
                                    <button type="button" size="sm" class="btn btn-outline-success btn-xs"
                                        v-on:click="detail(item, 'detail')">
                                        <i class="fas fa-eye"></i>
                                    </button>&nbsp;
                                    <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                        v-on:click="detail(item, 'update')">
                                        <i class="fas fa-pencil-alt"></i>
                                    </button>&nbsp;
                                    <button type="button" size="sm" class="btn btn-outline-danger btn-xs"
                                        v-on:click="showDeleteConfirm(item.id)">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <p> Selected Rows:<br>{{ selected }} </p> -->
                <!-- row info and paging -->
                <div class="row">
                    <div class="col-md-6">
                        <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng</div>
                        <div v-else>Không có dữ liệu</div>
                    </div>
                    <div class="col-md-6">
                        <div class="float-right">
                            <ul class="pagination pagination-rounded">
                                <paginate :page-count="pageCount" :page-range="3" :margin-pages="2"
                                    :click-handler="handlePageChange" :prev-text="'Trở lại'" :next-text="'Kế đến'"
                                    :container-class="'pagination'" :page-class="'page-item'">
                                </paginate>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--POP UP DETAIL-->
        <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="dynamic"> <!-- data-backdrop="static" -->
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{ title }}</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideDetailModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- <input type="hidden" v-model="model.id" /> -->
                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Tên lĩnh vực <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <input class="form-control" placeholder="Nhập tên lĩnh vực" v-model="model.reportName" @blur="validate()" :class="{ 'is-invalid': errors.reportName }" />
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" style="margin-top: -13 !important;" v-if="errors.reportName">{{ errors.reportName }}</small>

                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Chọn TTĐH <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <select id="workspaceOptions" class="form-control" style="width: 100%" v-model="model.workspaceId" @change="onSelectWorkspaceDetailForm(); validate();">
                                    <option v-for="item in workspaceOptions" :value="item.id" :key="item.id" :selected="model.workspaceId">{{ item.operatingCenterName }}</option>
                                </select>
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" v-if="errors.username">{{ errors.username }}</small>

                        <div class="row mb-2" v-if="!model.isWebUrl">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Chọn Power BI Report <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <select v-if="!isSelectingWorkspace" id="workspaceOptions" class="form-control" style="width: 100%" v-model="model.pbiReportId" @change=" validate();">
                                    <option v-for="item in reportOptions" :value="item.id" :key="item.id" :selected="model.pbiReportId">{{ item.name }}</option>
                                </select>
                                <div v-else class="spinner-border spinner-border-sm mr-1" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" v-if="errors.pbiReportId">{{ errors.pbiReportId }}</small>

                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                 
                            </label>
                            <div class="col-sm-9">

                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="isWebUrl" v-model="model.isWebUrl">
                                    <label class="custom-control-label" for="isWebUrl">Lĩnh vực nhúng web url?</label>
                                </div>

                            </div>
                        </div>

                        <div class="row mb-2" v-if="model.isWebUrl">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Web url <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <input class="form-control" placeholder="Nhập link" v-model="model.webUrl" @blur="validate()" :class="{ 'is-invalid': errors.webUrl }" />
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" style="margin-top: -13 !important;" v-if="errors.webUrl">{{ errors.webUrl }}</small>

                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Hình ảnh
                            </label>
                            <div class="col-sm-9">
                                <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="customFile" @change="onChangeReportImage($event)">
                                    <label class="custom-file-label" for="customFile">Choose file</label>
                                </div>
                            </div>
                            <div class="col-sm-3"></div>
                            <div class="col-sm-9">
                                <div class="image-preview mt-2" v-if="this.model.localImageUrl != null">
                                    <img v-bind:src="this.model.localImageUrl" width="100" style="border: 1px solid #d1cece; padding: 10px; border-radius: 5px;">
                                    <button class="btn btn-sm" v-on:click="onClearReportImage()">
                                        <i class="fas fa-trash-alt ml-2 text-danger clear-image"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" v-if="errors.localImage">{{ errors.localImage }}</small>

                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideDetailModal()">&nbsp;Đóng</button>
                        <button type="button" class="pull-right" :disabled="submitted" :class="styleButton" v-if="code != 'detail'" @click="onSubmit();">
                            <span v-if="submitted" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            &nbsp;{{ title }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- POP UP UPDATE STATUS  -->
        <div class="modal fade" id="updateStatusConfirm" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-danger">Cập nhật trạng thái</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideUpdateStatusConfirm()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <label>Cập nhật trạng thái lĩnh vực này?</label>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideUpdateStatusConfirm()">&nbsp;Đóng</button>
                        <button type="button" class="btn btn-outline-primary pull-right" @click="onSubmitUpdateStatus();">&nbsp;Cập nhật</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- POP UP CONFIRM DELETE  -->
        <div class="modal fade" id="deleteConfirm" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-danger">Xóa lĩnh vực</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideDeleteConfirm()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <label>Xóa lĩnh vực này?</label>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideDeleteConfirm()">&nbsp;Đóng</button>
                        <button type="button" class="btn btn-outline-danger pull-right" @click="onSubmitDelete();">&nbsp;Xóa</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- POP UP CONFIRM DELETE MANY  -->
        <div class="modal fade" id="deleteManyModal" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-danger">Xóa</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideDeleteManyModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <label>Bạn có chắc chắn xóa các item đã chọn?</label>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideDeleteManyModal()">&nbsp;Đóng</button>
                        <button type="button" class="btn btn-outline-danger pull-right" @click="onDeleteManySubmit();">&nbsp;Xóa</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import { reportModel } from '@/models/report.model.js'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import TheSwitch from '@/components/shared/UserInput/TheSwitch.vue';
import TheSelect from '@/components/shared/UserInput/TheSelect.vue';

export default {
    components: {
        paginate: Paginate,
        loading: Loading,
        TheSwitch,
        TheSelect
    },
    name: "TheReport",
    data() {
        return {
            isBusy: false,
            streamFileUrl: `${process.env.VUE_APP_API_URL}/Common/StreamFile?url=`,
            // table
            filter: null,
            items: [],
            exportDatas: [],
            currentPage: config.CURRENT_PAGE,
            perPage: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: "createdDate",
            sortDesc: true,
            filterOn: [],
            numberOfShow: 0,
            // model 
            model: reportModel.newModel(),

            selectedWorkspace: null,
            workspaceOptions: [],
            isSelectingWorkspace: false,

            selectedReport: null,
            reportOptions: [],

            selectedId: '',
            status: null,

            title: "",
            code: "",
            styleButton: "",
            // For mesage validate
            errors: {},
            submitted: false,
            selected: [],
            rowSelected: null,
            isUpdate: false
        }
    },
    methods: {
        // Map action
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('report', ['getReportByWorkspaceIdPaging', 'getPBIReports', 'createReport', 'updateReport', 'updateReportStatus', 'deleteReport', 'deleteManyReport']),
        ...mapActions('workspace', ['getAllWorkspace']),
        ...mapActions('alert', ['warning',]),
        // setup
        async setup() {
            //setup dynamic header
            let header = 'Quản lý lĩnh vực';
            this.setupHeader({ header });            
            
            // get workspaces
            let getWPResult = await this.getAllWorkspace();
            if(getWPResult.isOk) {
                this.workspaceOptions = getWPResult.data.data;
                this.selectedWorkspace = this.workspaceOptions.length > 0 ? this.workspaceOptions[0].id : "";
            }  
        },

        // ------ get data datatable ------
        async getData() {
            // state for loading overlay
            this.isBusy = true;
            // Set param for paging
            let params = {
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                searchKey: this.filter
            };

            // Call get data
            if(this.selectedWorkspace) {
                let rs = await this.getReportByWorkspaceIdPaging({params: params, workspaceId: this.selectedWorkspace});
                if(rs.isOk) {
                    // List data
                    this.items = rs.data.data;
                    // Total row
                    this.totalRow = rs.data.totalRow;
                    // Number show
                    this.numberOfShow = ((this.currentPage - 1) * this.perPage) + this.items.length;
                    // Total number page
                    this.pageCount = parseInt(((this.totalRow - 1) / this.perPage)) + 1;
                    // For export excel
                    this.exportDatas = this.items.map(({ rowNumber, id, reportName, workspaceId, powerBIUrl, powerBIReportUrl }) => ({
                        rowNumber, id, reportName, workspaceId, powerBIUrl, powerBIReportUrl
                    }));
                }
            }

            this.isBusy = false;
        },        
        // sortingChanged
        async sortingChanged() {
            //console.log(this.perPage)
            await this.getData();
        },
        // function for paging
        async handlePageChange(page) {
            this.currentPage = page;
            //console.log(this.currentPage)
            await this.getData();
        },
        // function for select number in page
        async onChangePageOptions(perPage) {
            this.perPage = perPage;
            await this.getData();
        },
        // function for search key 
        async onSearchKey() {
            //console.log(this.filter)
            //this.filter = e.target.value
            await this.getData();
        },
        // function select item in table
        async selectRow(id) {
            if (this.selected.includes(id)) {
                this.selected.splice(this.selected.indexOf(id), 1);
            }
            else {
                this.selected.push(id);
            }
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.selected = this.items.map((item) =>  item.id);
            }
            else {
                this.selected = [];
            }
        },

        // ------ render select report ------
        async renderSelectReports() {
            if(this.model.workspaceId) {
                let rs = await this.getPBIReports(this.model.workspaceId);
                if(rs.isOk) {
                    this.reportOptions = rs.data.data;
                }
            }
        },

        
        // ------ show/hide detail popup ------
        async detail(item, code) {
            // set notifi error
            this.errors = {
                
            };
            // prepare model
            this.code = code;
            this.title = this.$t('labels.' + code);
            this.styleButton = this.$t('labels.styleButton' + code);
            this.model = item != null ? JSON.parse(JSON.stringify(item)) : reportModel.newModel();
            
            this.isUpdate = (code == "create") ? false : true;

            if(item && this.model.imageUrl && this.model.imageUrl.trim().length > 0) {
                this.model.localImageUrl = this.streamFileUrl + item.imageUrl;
            }

            this.renderSelectReports();

            // show popup
            this.showDetailModal();
        },
        async showDetailModal() {
            $('#detailModal').modal('show');
        },
        async hideDetailModal() {
            $('#detailModal').modal('hide');
            await this.getData();
        },

        // ------ show/hide delete confirm ------
        async showDeleteConfirm(id) {
            this.selectedId = id;
            $('#deleteConfirm').modal('show');
        },
        async hideDeleteConfirm() {
            $('#deleteConfirm').modal('hide');
        },
        
        // ------ show/hide delete many confirm modal ------
        async showDeleteManyModal() {
            if (this.selected.length == 0) {
                this.warning('Chưa chọn dòng để xóa');
            }
            else {
                $('#deleteManyModal').modal('show');
            }
        },
        async hideDeleteManyModal() {
            $('#deleteManyModal').modal('hide');
        },

        // ------ function validate ------
        async validate() {
            let isvalid = true
            this.errors = {
                reportName: '',
                workspaceId: '',
                pbiReportId: '',
                localImage: '',
            };

            // check null model
            if (!this.model.reportName) {
                this.errors.reportName = "Nhập tên report";
                isvalid = false;
            }
            if (!this.model.workspaceId) {
                this.errors.workspaceId = 'Chọn workspace';
                isvalid = false;
            }
            if (!this.model.isWebUrl && !this.model.pbiReportId) {
                this.errors.pbiReportId = 'Chọn Power BI report';
                isvalid = false;
            }
            if (this.model.isWebUrl && !this.model.webUrl) {
                this.errors.webUrl = 'Nhập web url';
                isvalid = false;
            }
            let imageType = ["image/gif", "image/jpeg", "image/png"];
            if(this.model.localImage && !imageType.includes(this.model.localImage.type)) {
                this.errors.localImage = 'Không phải hình ảnh';
                isvalid = false;
            }
            console.log(isvalid);
            return isvalid;
        },

        // ------ on select workspace (create, update) ------
        async onSelectWorkspaceDetailForm(){
            this.isSelectingWorkspace = true;
            await this.renderSelectReports();
            this.isSelectingWorkspace = false;
        },

        // ------ on change report image (create, update) -------
        onChangeReportImage(event) {
            if(event.target.files.length > 0) {
                this.model.localImage = event.target.files[0];
                this.model.localImageUrl = URL.createObjectURL(this.model.localImage);
                this.model.isChangedImage = true;
            }
        },

        // ------ on clear report image (create, update) ------
        onClearReportImage(){
            this.model.localImage = null;
            this.model.localImageUrl = null;
            this.model.isChangedImage = true;
        },

        // ------ on check update status -----
        onCheckUpdateStatus(e){
            this.showUpdateStatusConfirm();
            this.selectedId = e.target.value;
            this.status = e.target.checked;
        },

        // ------ show/hide update status confirm modal ------
        async showUpdateStatusConfirm() {
            $('#updateStatusConfirm').modal('show');
        },
        async hideUpdateStatusConfirm() {
            $('#updateStatusConfirm').modal('hide');
        },

        // ------ create, update submit ------
        async onSubmit() {
            this.submitted = true;
            if (await this.validate()) {
                let reportInfo = this.reportOptions.filter(e => e.id === this.model.pbiReportId)[0];
                this.model.pbiReportInfoStr = JSON.stringify(reportInfo);

                // create
                if (this.code == "create") {
                    await this.createReport(this.model);
                }
                // update
                if (this.code == "update") {
                    await this.updateReport(this.model);
                }
                this.hideDetailModal();
                await this.getData();
            }
            this.submitted = false;
        },

        // ------ update status submit -----
        async onSubmitUpdateStatus () {
            this.submitted = true;
            await this.updateReportStatus({id: this.selectedId, status: this.status});
            this.hideUpdateStatusConfirm();
            this.submitted = false;
        },

        // ------ delete submit ------
        async onSubmitDelete() {
            this.submitted = true;
            await this.deleteReport(this.selectedId);
            this.getData();
            this.hideDeleteConfirm();
            this.submitted = false;
        },
        
        // ------ delete many submit ------
        async onDeleteManySubmit() {
            this.submitted = true;
            if (this.selected.length == 0) {
                this.warning('Chưa chọn dòng để xóa');
            }
            else {
                let ids = [];
                ids = this.selected.map(item => item);
                await this.deleteManyReport(ids);
                await this.getData();
                this.selected = [];
            }
            await this.hideDeleteManyModal();
            this.submitted = false;
        },
    },
    async mounted() {
        // setup title header
        await this.setup();
        // get data table
        await this.getData();
        //Initialize Select2 Elements
        // $(".select2").select2();
        // //Initialize Select2 Elements
        // $(".select2bs4").select2({
        //     theme: "bootstrap4",
        // });
        // $('#pageOptions').on('change', e => {
        //     this.onChangePageOptions(e.target.value);
        // });
        $("#workspaceOptions").select2({
            theme: "bootstrap4",
        });
        $('#workspaceOptions').on('change', e => {
            this.selectedWorkspace = e.target.value;
            this.getData();
        });
    },
    async created() {

    }
}
</script>

<style>

</style>
